<template>
  <div class="mapbackgroundslider">
    <div class="p-line"></div>
    <!-- <div class="p-lable">地图基础属性</div> -->
    <div class="p-opacityslider-wrap">
      <div class="center">
        <p>中心位置</p>
        <div class="lngandlat">
          <el-input placeholder="经度" v-model="value.coordinate.lng" @change="changeSetting"> </el-input>
          <span>-</span>
          <el-input placeholder="纬度" v-model="value.coordinate.lat" @change="changeSetting"> </el-input>
          <img @click="changeSetting" src="img/backgrounds/icon/centermarker.png" alt="" />
        </div>
      </div>
      <div class="zoom">
        <p>缩放</p>
        <el-select size="mini" v-model="value.zoom" placeholder="缩放等级" @change="changeSetting">
          <el-option
            v-for="item in [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18]"
            :key="item"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
      </div>
      <!-- <div class="is3d" v-if="propertyData.mapType.value.type == 0 ? false : true">
        <p>是否开启3d模式</p>
        <el-switch
          v-model="value.is3dMap"
          active-color="#1989fa"
          inactive-color="#333"
          @change="changeSetting"
        >
        </el-switch>
      </div> -->
      <!-- <el-slider v-model="value" :step="0.05" :max="1"> </el-slider> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'mapBasicSetting',
  props: {
    CurrentConfigration: Object,
    propertyData: Object,
    propertyDataKey: String,
  },
  watch: {
    propertyData: {
      deep: true,
      handler: function (newValue) {
        console.log(newValue);
        this.value.zoom = newValue.mapBasicSetting.value.zoom;
      },
    },
  },
  data() {
    return {
      value: this.propertyData.mapBasicSetting.value,
    };
  },
  methods: {
    changeSetting() {
      console.log(this.value);
      /* 更新数据 */

      this.$store.commit('update_PropertyData', {
        key: this.propertyDataKey,
        value: this.value,
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.mapbackgroundslider {
  width: 100%;
  margin-bottom: 15px;
  box-sizing: border-box;
  // padding: 0 10px;
  .p-lable {
    box-sizing: border-box;
    padding: 0 15px;
    width: 100%;
    height: 30px;
    color: #5b5c66;
    font-size: 12px;
    line-height: 30px;
  }
}
.demo-input-label {
  display: inline-block;
  width: 130px;
}
.center > {
  div {
    display: flex;
    align-items: center;
    padding: 0 15px;
  }

  p {
    box-sizing: border-box;
    padding: 0 15px;
    width: 100%;
    height: 20px;
    color: #a0a1b4;
    font-size: 14px;
    line-height: 20px;
  }
  .lngandlat {
    display: flex;
    align-items: center;
    padding: 0 15px;
    :deep() input {
      color: #ffffff;
    }
    img {
      // padding: 0 10px;
      width: 26px;
      height: 26px;
      margin-left: 5px;
    }
    span {
      margin: 0 5px;
    }
  }
}
.center {
  margin-bottom: 10px;
  :deep() .el-input__inner {
    padding: 0 8px;
  }
  .el-input {
    display: flex;
    align-items: center;
    display: inline-block;
    height: 35px;
    width: 98px;
    :deep(input) {
      border-radius: 0;
      height: 28px;
      width: 98px;
      background: #191b23;
      border: 1px solid #5e6167;
    }
  }
}
.zoom > {
  div {
    display: flex;
    align-items: center;
  }
  p {
    box-sizing: border-box;
    width: 50px;
    height: 30px;
    color: #a0a1b4;
    font-size: 14px;
    line-height: 30px;
  }
}
.zoom {
  padding: 0 15px;
  display: flex;
  align-items: center;
  .el-select {
    width: 192px;

    :deep() input {
      color: #ffffff;
      background: #191b23;
      border-radius: 0;
      border-collapse: collapse;
      text-align: center;
      border: 1px solid rgb(90, 90, 90);

      &:hover {
        border: 1px solid #3179ff;
      }
      &:focus {
        border: 1px solid #3179ff;
      }
    }
  }
}
.is3d > {
  div {
    display: flex;
    align-items: center;
  }
  p {
    box-sizing: border-box;
    width: 150px;
    height: 30px;
    color: #a0a1b4;
    font-size: 14px;
    line-height: 30px;
  }
}
.is3d {
  padding: 10px 15px;
  padding-bottom: 0px;
  display: flex;
  align-items: center;
  .el-select {
    width: 192px;

    :deep() input {
      color: #ffffff;
      background: #191b23;
      border-radius: 0;
      border-collapse: collapse;
      text-align: center;
      border: 1px solid rgb(90, 90, 90);

      &:hover {
        border: 1px solid #3179ff;
      }
      &:focus {
        border: 1px solid #3179ff;
      }
    }
  }
}
</style>
